<template>
  <div>
    <div class="container-fluid mb-3 d-md-none">
      <div class="card shadow-sm">
        <div
          class="card-body p-2 d-flex justify-content-between align-items-center"
        >
          <h5 class="mb-0 text-muted ps-2 fs-6">Monitoramento</h5>
          <div>
            <router-link class="btn btn-primary btn-sm ms-2" to="/nova-os">
              <i class="material-icons align-middle" style="font-size: 1.2rem"
                >add</i
              >
              <span class="d-none d-sm-inline">Nova OS</span>
            </router-link>
            <button id="btn-confirm-delivery" class="btn btn-success mx-2 float-end" v-on:click="deliverAll">
              Confirmar entregas
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="d-none d-md-block">
      <div class="monitor-kanban">
        <div class="row">
          <div class="col-md-4 mt-3 mt-md-0">
            <div class="card border border-secondary">
              <div class="card-header bg-secondary">
                <h5 class="text-white mb-0">
                  Agendados ({{ queueWaiting.length }})
                </h5>
              </div>
              <div v-if="loading" class="card-body text-center p-5">
                <div class="spinner-border text-secondary"></div>
              </div>
              <div v-else class="card-body scrollable-column">
                <div
                  v-for="w in queueWaiting"
                  :key="w.id"
                  class="vehicle-card card border mb-2"
                  :class="'border-' + priority[w.priority]"
                >
                <div
                    class="card-header py-1 cursor-pointer"
                    :class="'bg-' + priority[w.priority]"
                    @click="openDetailModal(w.id)"
                  >
                    <strong class="text-white">{{ w.vehicle }}</strong>
                    <span class="badge bg-dark ms-1">{{ w.plate }}</span>
                  </div>
                  <div
                    class="card-header py-1 cursor-pointer"
                    v-if="w.origin === 3 || w.origin === 4"
                    @click="openDetailModal(w.id)"
                  >
                    <span class="badge ms-1" :style="{
                          backgroundColor: w.prism_hex,
                          color: getContrastYIQ(w.prism_hex),
                        }">{{ w.prism }}</span>
                  </div>
                  <div
                    class="card-body py-1 cursor-pointer"
                    :class="w.enough_time == true ? '' : 'bg-danger-subtle'"
                    @click="openDetailModal(w.id)"
                  >
                    <span class="align-middle" v-if="w.os_number"
                      ><strong>OS:</strong> {{ w.os_number }}<br />
                      <strong>Entrega:</strong> {{ w.hora_entrega_f }}</span
                    >
                    <div class="py-1">
                      <div
                        class="form-check"
                        v-for="serv in w.services"
                        :key="serv.id"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          disabled
                          :checked="serv.concluded_at"
                        /><label class="form-check-label">{{
                          serv.name
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="w.enough_time == false"
                    class="card-body py-1 bg-danger-subtle text-danger small fw-bold"
                  >
                    Atenção: Tempo insuficiente!
                  </div>
                  <div class="card-footer text-end">
                    <button
                      class="btn btn-success btn-sm"
                      @click="sendToWash(w.id)"
                    >
                      Enviar p/ Lavagem
                      <i class="material-icons inline-icon">chevron_right</i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8 mt-3 mt-md-0">
            <div class="card border border-primary">
              <div
                class="card-header bg-primary d-flex justify-content-between align-items-center"
              >
                <h5 class="mb-0 text-white">Monitoramento de Fila</h5>
                <h5 class="mb-0 text-white">{{ date }}</h5>
              </div>
              <div v-if="loading" class="card-body text-center p-5">
                <div class="spinner-border text-primary"></div>
              </div>
              <div
                v-else-if="Object.keys(statusList).length > 0"
                id="scrum"
                class="card-body scrollable-column"
                style="max-height: 80vh"
              >
                <div class="row">
                  <div class="col-md-3">
                    <h5 class="text-center mb-2">
                      Aguardando ({{ queue[statusList["aguardando"]].length }})
                    </h5>
                    <div
                      v-for="v in queue[statusList['aguardando']]"
                      :key="v.id"
                      class="vehicle-card card border mb-2"
                      :class="'border-' + priority[v.priority]"
                    >
                      <div>
                        <div
                          class="card-header py-1 cursor-pointer"
                          :class="'bg-' + priority[v.priority]"
                          @click="openDetailModal(v.id)"
                        >
                          <strong class="text-white">{{ v.vehicle }}</strong>
                          <span class="badge bg-dark ms-1">{{ v.plate }}</span>
                        </div>
                        <div
                          class="card-header py-1 cursor-pointer"
                          v-if="v.origin === 3 || v.origin === 4"
                          @click="openDetailModal(v.id)"
                        >
                          <span class="badge ms-1" :style="{
                          backgroundColor: v.prism_hex,
                          color: getContrastYIQ(v.prism_hex),
                        }">{{ v.prism }}</span>
                        </div>
                        <div class="card-body py-1 cursor-pointer"
                          @click="openDetailModal(v.id)"
                        >
                          <span v-if="v.os_number"><strong>OS:</strong> {{ v.os_number }} <br/></span>
                          <strong>Entrega:</strong> {{ v.hora_entrega_f }}
                          <div class="py-1">
                            <div
                              class="form-check"
                              v-for="serv in v.services"
                              :key="serv.id"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                disabled
                                :checked="serv.concluded_at"
                              /><label class="form-check-label">{{
                                serv.name
                              }}</label>
                            </div>
                          </div>
                        </div>

                        <div class="card-footer" v-if="this.user.admin && v.origin !== 2">
				          <button class="btn btn-warning" v-on:click="sendToSchedule(v.id)">
				             <i class="material-icons inline-icon">arrow_back</i> Voltar
				          </button>
				        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <h5 class="text-center mb-2">
                      Lavagem ({{ queue[statusList["lavagem"]].length }})
                    </h5>
                    <div
                      v-for="v in queue[statusList['lavagem']]"
                      :key="v.id"
                      class="vehicle-card card border mb-2"
                      :class="'border-' + priority[v.priority]"
                    >
                      <div
                        class="cursor-pointer"
                        @click="openDetailModal(v.id)"
                      >
                        <div
                          class="card-header py-1"
                          :class="'bg-' + priority[v.priority]"
                        >
                          <strong class="text-white">{{ v.vehicle }}</strong>
                          <span class="badge bg-dark ms-1">{{ v.plate }}</span>
                        </div>
                        <div
                          class="card-header py-1 cursor-pointer"
                          v-if="v.origin === 3 || v.origin === 4"
                          @click="openDetailModal(v.id)"
                        >
                          <span class="badge ms-1" :style="{
                          backgroundColor: v.prism_hex,
                          color: getContrastYIQ(v.prism_hex),
                        }">{{ v.prism }}</span>
                        </div>
                        <div class="card-body py-1">
                          <span v-if="v.os_number"><strong>OS:</strong> {{ v.os_number }} <br/></span>
                          <strong>Entrega:</strong> {{ v.hora_entrega_f }}
                          <div class="py-1">
                            <div
                              class="form-check"
                              v-for="serv in v.services"
                              :key="serv.id"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                disabled
                                :checked="serv.concluded_at"
                              /><label class="form-check-label">{{
                                serv.name
                              }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <h5 class="text-center mb-2">
                      Acabamento ({{ queue[statusList["acabamento"]].length }})
                    </h5>
                    <div
                      v-for="v in queue[statusList['acabamento']]"
                      :key="v.id"
                      class="vehicle-card card border mb-2"
                      :class="'border-' + priority[v.priority]"
                    >
                      <div
                        class="cursor-pointer"
                        @click="openDetailModal(v.id)"
                      >
                        <div
                          class="card-header py-1"
                          :class="'bg-' + priority[v.priority]"
                        >
                          <strong class="text-white">{{ v.vehicle }}</strong>
                          <span class="badge bg-dark ms-1">{{ v.plate }}</span>
                        </div>
                        <div
                          class="card-header py-1 cursor-pointer"
                          v-if="v.origin === 3 || v.origin === 4"
                          @click="openDetailModal(v.id)"
                        >
                          <span class="badge ms-1" :style="{
                          backgroundColor: v.prism_hex,
                          color: getContrastYIQ(v.prism_hex),
                        }">{{ v.prism }}</span>
                        </div>
                        <div class="card-body py-1">
                          <span v-if="v.os_number"><strong>OS:</strong> {{ v.os_number }} <br/></span>
                          <strong>Entrega:</strong> {{ v.hora_entrega_f }}
                          <div class="py-1">
                            <div
                              class="form-check"
                              v-for="serv in v.services"
                              :key="serv.id"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                disabled
                                :checked="serv.concluded_at"
                              /><label class="form-check-label">{{
                                serv.name
                              }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <h5 class="text-center mb-2">
                      Aguard. Entrega ({{
                        queue[statusList["concluido"]].length
                      }})
                    </h5>
                    <div
                      v-for="v in queue[statusList['concluido']]"
                      :key="v.id"
                      class="vehicle-card card border mb-2"
                      :class="
                        'border-' +
                        (v.priority == 2 ? 'success' : priority[v.priority])
                      "
                    >
                      <div
                        class="cursor-pointer"
                        @click="openDetailModal(v.id)"
                      >
                        <div
                          class="card-header py-1"
                          :class="
                            'bg-' +
                            (v.priority == 2 ? 'success' : priority[v.priority])
                          "
                        >
                          <strong class="text-white">{{ v.vehicle }}</strong>
                          <span class="badge bg-dark ms-1">{{ v.plate }}</span>
                        </div>
                        <div
                          class="card-header py-1 cursor-pointer"
                          v-if="v.origin === 3 || v.origin === 4"
                          @click="openDetailModal(v.id)"
                        >
                          <span class="badge ms-1" :style="{
                          backgroundColor: v.prism_hex,
                          color: getContrastYIQ(v.prism_hex),
                        }">{{ v.prism }}</span>
                        </div>
                        <div class="card-body py-1">
                          <span v-if="v.os_number"><strong>OS:</strong> {{ v.os_number }} <br/></span>
                          <strong>Entrega:</strong> {{ v.hora_entrega_f }}
                          <div class="py-1">
                            <div
                              class="form-check"
                              v-for="serv in v.services"
                              :key="serv.id"
                            >
                              <input
                                class="form-check-input"
                                type="checkbox"
                                disabled
                                :checked="serv.concluded_at"
                              /><label class="form-check-label">{{
                                serv.name
                              }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <router-link to="/nova-os" class="btn btn-primary">
                  Nova OS
                </router-link>
                <button id="btn-confirm-delivery" class="btn btn-success mx-2 float-end" v-on:click="deliverAll">
		          Confirmar entregas
		        </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="d-md-none"
      v-if="!loading && Object.keys(statusList).length > 0"
    >
      <ul class="nav nav-tabs nav-fill" id="mobileTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="agendados-tab-m"
            data-bs-toggle="tab"
            data-bs-target="#agendados-m"
            type="button"
            role="tab"
          >
            Ag.
            <span class="badge rounded-pill bg-secondary">{{
              queueWaiting.length
            }}</span>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="aguardando-tab-m"
            data-bs-toggle="tab"
            data-bs-target="#aguardando-m"
            type="button"
            role="tab"
          >
            Aguard.
            <span class="badge rounded-pill bg-primary">{{
              queue[statusList["aguardando"]].length
            }}</span>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="lavagem-tab-m"
            data-bs-toggle="tab"
            data-bs-target="#lavagem-m"
            type="button"
            role="tab"
          >
            Lav.
            <span class="badge rounded-pill bg-info text-dark">{{
              queue[statusList["lavagem"]].length
            }}</span>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="acabamento-tab-m"
            data-bs-toggle="tab"
            data-bs-target="#acabamento-m"
            type="button"
            role="tab"
          >
            Acab.
            <span class="badge rounded-pill bg-dark">{{
              queue[statusList["acabamento"]].length
            }}</span>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="entrega-tab-m"
            data-bs-toggle="tab"
            data-bs-target="#concluido-m"
            type="button"
            role="tab"
          >
            Entr.
            <span class="badge rounded-pill bg-success">{{
              queue[statusList["concluido"]].length
            }}</span>
          </button>
        </li>
      </ul>

      <div class="tab-content p-2" id="mobileTabContent">
        <div
          class="tab-pane fade show active mobile-tab-pane"
          id="agendados-m"
          role="tabpanel"
        >
          <div
            v-for="w in queueWaiting"
            :key="w.id"
            class="vehicle-card card border mb-2"
            :class="'border-' + priority[w.priority]"
          >
            <div
              class="card-header py-1 cursor-pointer"
              :class="'bg-' + priority[w.priority]"
              @click="openDetailModal(w.id)"
            >
              <strong class="text-white">{{ w.vehicle }}</strong>
              <span class="badge bg-dark ms-1">{{ w.plate }}</span>
            </div>
            <div
              class="card-header py-1 cursor-pointer"
              v-if="w.origin === 3 || w.origin === 4"
              @click="openDetailModal(w.id)"
            >
              <span class="badge ms-1" :style="'background-color: ' + w.prism_hex">{{ w.prism }}</span>
            </div>
            <div
              class="card-body py-1 cursor-pointer"
              :class="w.enough_time == true ? '' : 'bg-danger-subtle'"
              @click="openDetailModal(w.id)"
            >
              <span class="align-middle"
                ><strong>OS:</strong> {{ w.os_number ?? '--' }} |
                <strong>Entrega:</strong> {{ w.hora_entrega_f }}</span
              >
              <div class="py-1">
                <div
                  class="form-check"
                  v-for="serv in w.services"
                  :key="serv.id"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    disabled
                    :checked="serv.concluded_at"
                  /><label class="form-check-label">{{ serv.name }}</label>
                </div>
              </div>
            </div>
            <div
              v-if="w.enough_time == false"
              class="card-body py-1 bg-danger-subtle text-danger small fw-bold"
            >
              Atenção: Tempo insuficiente!
            </div>
            <div class="card-footer text-end p-2">
              <button class="btn btn-success btn-sm" @click="sendToWash(w.id)">
                Enviar p/ Lavagem
                <i class="material-icons inline-icon">chevron_right</i>
              </button>
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade mobile-tab-pane"
          id="aguardando-m"
          role="tabpanel"
        >
          <div
            v-for="v in queue[statusList['aguardando']]"
            :key="v.id"
            class="vehicle-card card border mb-2"
            :class="'border-' + priority[v.priority]"
          >
            <div class="cursor-pointer" @click="openDetailModal(v.id)">
              <div
                class="card-header py-1"
                :class="'bg-' + priority[v.priority]"
              >
                <strong class="text-white">{{ v.vehicle }}</strong>
                <span class="badge bg-dark ms-1">{{ v.plate }}</span>
              </div>
              <div
                class="card-header py-1"
                v-if="v.origin === 3 || v.origin === 4"
              >
                <span class="badge ms-1" :style="'background-color: ' + v.prism_hex">{{ v.prism }}</span>
              </div>
              <div class="card-body py-1">
                <span v-if="v.os_number"><strong>OS:</strong> {{ v.os_number ?? '--' }} <br></span>
                <strong>Entrega:</strong> {{ v.hora_entrega_f }}
                <div class="py-1">
                  <div
                    class="form-check"
                    v-for="serv in v.services"
                    :key="serv.id"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      disabled
                      :checked="serv.concluded_at"
                    /><label class="form-check-label">{{ serv.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade mobile-tab-pane"
          id="lavagem-m"
          role="tabpanel"
        >
          <div
            v-for="v in queue[statusList['lavagem']]"
            :key="v.id"
            class="vehicle-card card border mb-2"
            :class="'border-' + priority[v.priority]"
          >
            <div class="cursor-pointer" @click="openDetailModal(v.id)">
              <div
                class="card-header py-1"
                :class="'bg-' + priority[v.priority]"
              >
                <strong class="text-white">{{ v.vehicle }}</strong>
                <span class="badge bg-dark ms-1">{{ v.plate }}</span>
              </div>
              <div
                class="card-header py-1"
                v-if="v.origin === 3 || v.origin === 4"
              >
                <span class="badge ms-1" :style="'background-color: ' + v.prism_hex">{{ v.prism }}</span>
              </div>
              <div class="card-body py-1">
                <span v-if="v.os_number"><strong>OS:</strong> {{ v.os_number ?? '--' }} <br></span>
                <strong>Entrega:</strong> {{ v.hora_entrega_f }}
                <div class="py-1">
                  <div
                    class="form-check"
                    v-for="serv in v.services"
                    :key="serv.id"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      disabled
                      :checked="serv.concluded_at"
                    /><label class="form-check-label">{{ serv.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade mobile-tab-pane"
          id="acabamento-m"
          role="tabpanel"
        >
          <div
            v-for="v in queue[statusList['acabamento']]"
            :key="v.id"
            class="vehicle-card card border mb-2"
            :class="'border-' + priority[v.priority]"
          >
            <div class="cursor-pointer" @click="openDetailModal(v.id)">
              <div
                class="card-header py-1"
                :class="'bg-' + priority[v.priority]"
              >
                <strong class="text-white">{{ v.vehicle }}</strong>
                <span class="badge bg-dark ms-1">{{ v.plate }}</span>
              </div>
              <div
                class="card-header py-1"
                v-if="v.origin === 3 || v.origin === 4"
              >
                <span class="badge ms-1" :style="'background-color: ' + v.prism_hex">{{ v.prism }}</span>
              </div>
              <div class="card-body py-1">
                <span v-if="v.os_number"><strong>OS:</strong> {{ v.os_number ?? '--' }} <br></span>
                <strong>Entrega:</strong> {{ v.hora_entrega_f }}
                <div class="py-1">
                  <div
                    class="form-check"
                    v-for="serv in v.services"
                    :key="serv.id"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      disabled
                      :checked="serv.concluded_at"
                    /><label class="form-check-label">{{ serv.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade mobile-tab-pane"
          id="concluido-m"
          role="tabpanel"
        >
          <div
            v-for="v in queue[statusList['concluido']]"
            :key="v.id"
            class="vehicle-card card border mb-2"
            :class="
              'border-' + (v.priority == 2 ? 'success' : priority[v.priority])
            "
          >
            <div class="cursor-pointer" @click="openDetailModal(v.id)">
              <div
                class="card-header py-1"
                :class="
                  'bg-' + (v.priority == 2 ? 'success' : priority[v.priority])
                "
              >
                <strong class="text-white">{{ v.vehicle }}</strong>
                <span class="badge bg-dark ms-1">{{ v.plate }}</span>
              </div>
              <div
                class="card-header py-1"
                v-if="v.origin === 3 || v.origin === 4"
              >
                <span class="badge ms-1" :style="'background-color: ' + v.prism_hex">{{ v.prism }}</span>
              </div>
              <div class="card-body py-1">
                <span v-if="v.os_number"><strong>OS:</strong> {{ v.os_number ?? '--' }} <br></span>
                <strong>Entrega:</strong> {{ v.hora_entrega_f }}
                <div class="py-1">
                  <div
                    class="form-check"
                    v-for="serv in v.services"
                    :key="serv.id"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      disabled
                      :checked="serv.concluded_at"
                    /><label class="form-check-label">{{ serv.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-md-none text-center p-5" v-if="loading">
      <div
        class="spinner-border text-primary"
        style="width: 3rem; height: 3rem"
      ></div>
      <p class="mt-2">Carregando dados...</p>
    </div>

    <ModalMonitor
      :detail="osDetail"
      :loading="modalLoading"
      :services="services"
    ></ModalMonitor>

    <div
      class="modal fade"
      id="modalCharts"
      tabindex="-1"
      aria-labelledby="modalChartsLabel"
      aria-hidden="true"
    ></div>
  </div>
</template>

<script>
import Helper from "@/components/Helper.vue";
import ModalMonitor from "@/components/Monitor/ModalMonitor.vue";
import Swal from "sweetalert2";
import { Popover } from "bootstrap";
import { Bar, Pie } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { ref } from "vue";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { reverb } from "../../server.json";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  ChartDataLabels,
);

export default {
  name: "Monitor",
  components: {
    ModalMonitor,
    Pie,
    Bar,
  },
  data() {
    return {
      loading: true,
      onlyMine: false,
      date: "",
      queue: { 1: [], 2: [], 3: [], 4: [] },
      queueWaiting: [],
      averages: {
        1: { seconds: 0, formatted: "0", percentual: "0%" },
        2: { seconds: 0, formatted: "0", percentual: "0%" },
        3: { seconds: 0, formatted: "0", percentual: "0%" },
        total: { seconds: 0, formatted: "0", percentual: "0%" },
      },
      priority: { 1: "info", 2: "secondary", 3: "primary", 4: "danger" },
      osDetail: {},
      modalLoading: true,
      services: [],
      chartDataBar: {},
      chartOptionsBar: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          datalabels: {
            anchor: "end",
            align: "top",
            color: "#363636",
            font: { weight: "bold" },
            formatter: (value) => {
              return value > 0 ? value : "";
            },
          },
        },
      },
      chartOptionsPie: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: "top" },
          datalabels: {
            formatter: (value, ctx) => {
              const datapoints = ctx.chart.data.datasets[0].data;
              const total = datapoints.reduce(
                (total, datapoint) => total + datapoint,
                0,
              );
              const percentage = (value / total) * 100;
              if (value === 0) return "";
              return percentage.toFixed(2) + "%";
            },
            color: "#fff",
            font: { weight: "bold", size: 14 },
          },
        },
      },
      chartDataPie: {},
      statusList: [],
      user: {},
      echo: {},
      changed: { id: 0, status: 0, status_old: 0 },
    };
  },
  beforeMount() {
    if (!Helper.checkLogin()) {
      this.$router.push("/login");
    }
    this.user = JSON.parse(sessionStorage.getItem("user"));
    if (!this.user) {
      this.$router.push("/login");
    }
    Helper.request.Monitor.make = true;
    this.getStatusList();
  },
  unmounted() {
    Helper.request.Monitor.make = false;
    if (this.echo && this.echo.leave) {
      this.echo.channel("dailymonitoring").stopListening("UpdateServiceReport");
      this.echo.leave("dailymonitoring");
      this.echo.channel("checkdelays").stopListening("CheckDelaysEvent");
      this.echo.leave("checkdelays");
      this.echo.channel("updateservices").stopListening("UpdateServicesEvent");
      this.echo.leave("updateservices");
    }
  },
  mounted() {
    new Popover(document.body, {
      selector: "[data-bs-toggle='popover']",
      trigger: "hover",
      placement: "bottom",
    });
    this.getServices();
    this.setupEcho();
    this.getMonitorData();
  },
  methods: {
    getContrastYIQ(hexcolor) {
      if (!hexcolor) return "#000";
      if (hexcolor.startsWith("#")) {
        hexcolor = hexcolor.substring(1);
      }
      var r = parseInt(hexcolor.substr(0, 2), 16);
      var g = parseInt(hexcolor.substr(2, 2), 16);
      var b = parseInt(hexcolor.substr(4, 2), 16);
      var yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq >= 128 ? "#000" : "#fff";
    },
    setupEcho() {
      this.echo = new Echo({
        broadcaster: "reverb",
        key: reverb.key,
        wsHost: reverb.host,
        wsPort: reverb.port,
        wssPort: reverb.port,
        forceTLS: false,
        enabledTransports: ["ws", "wss"],
      });

      this.echo
        .channel("dailymonitoring")
        .listen("UpdateServiceReport", (e) => {
          if (e.opr === 4) {
            this.getMonitorData();
            return;
          }
          if (e.opr === 1) {
            this.addVehicle(e.car);
          }
          if (e.opr === 2) {
            this.updVehicle(e.car);
          }
          if (e.opr === 3) {
            this.delVehicle(e.car);
          }
        });

      this.echo.channel("checkdelays").listen("CheckDelaysEvent", (e) => {
        this.updateDelayed(e.car.id, e.car.status, e.car.has_time);
      });

      this.echo.channel("updateservices").listen("UpdateServicesEvent", (e) => {
        let list = e.status === -2 ? this.queueWaiting : this.queue[e.status];
        if (list) {
          const vehicle = list.find((v) => v.id === e.id);
          if (vehicle) vehicle.services = e.services;
        }
      });
    },
    updateDelayed(id, status, enough = false) {
      let list = status === -2 ? this.queueWaiting : this.queue[status];
      if (list) {
        const vehicle = list.find((v) => v.id === id);
        if (vehicle) vehicle.enough_time = enough;
      }
    },
    addVehicle(data) {
      let list =
        data.status === -2 ? this.queueWaiting : this.queue[data.status];
      if (list) list.push(data);
    },
    updVehicle(data) {
      let fromList =
        data.status_old === -2
          ? this.queueWaiting
          : this.queue[data.status_old];
      let toList =
        data.status === -2 ? this.queueWaiting : this.queue[data.status];

      if (!fromList || !toList) return;

      const vehicleIndex = fromList.findIndex((v) => v.id === data.id);
      if (vehicleIndex === -1) return;

      if (data.status === data.status_old) {
        Object.assign(fromList[vehicleIndex], data);
      } else {
        const [vehicle] = fromList.splice(vehicleIndex, 1);
        Object.assign(vehicle, data);
        toList.push(vehicle);
      }
    },
    delVehicle(data) {
      let list =
        data.status_old === -2
          ? this.queueWaiting
          : this.queue[data.status_old];
      if (list) {
        const index = list.findIndex((v) => v.id === data.id);
        if (index > -1) list.splice(index, 1);
      }
    },
    sendToSchedule(id) {
      Swal.fire({
        title: "Retornar para lista de agendado?",
        html: "Confirmar que veículo saiu do estacionamento e deve voltar para fila de agendados?",
        icon: "info",
        showCancelButton: true,
        //confirmButtonColor: "#3085d6",
        //cancelButtonColor: "#d33",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          Helper.axiosRequest({
            url: "/admin/status/" + id,
            body: {status: -2},
            method: "patch",
            onFail: (err) => {
              console.log(err)
              Swal.fire({
                title: "Ocorreu um erro inesperado",
                html: err.response.data.message,
                icon: "error",
              })
            },
            onSuccess: () => {
              Swal.fire({
                icon: "success",
                title: "Veículo na fila de agendados",
              }).then((res) => {
                //this.getMonitorWaiting()
                //this.getMonitorData()

                //$('#modal-vehicle-detail').modal("hide")
              })
            }
          })
        }
      })
    },
    sendToWash(id) {
      Swal.fire({
        title: "Veículo pronto para lavagem?",
        text: "Confirmar que o veículo já está pronto para iniciar o processo?",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          Helper.axiosRequest({
            url: `/admin/status/${id}`,
            body: { status: 3 },
            method: "patch",
            onSuccess: () =>
              Swal.fire(
                "Sucesso!",
                "Veículo enviado para a próxima etapa.",
                "success",
              ),
            onFail: (err) =>
              Swal.fire("Erro", err.response.data.message, "error"),
          });
        }
      });
    },
    getMonitorData() {
      this.loading = true;
      Helper.axiosRequest({
        url: "/admin/monitor",
        onSuccess: (response) => {
          this.queue = response.data.result.queue;
          this.queueWaiting = this.queue[this.statusList["agendado"]] || [];
          if (response.data.result.averages)
            this.averages = response.data.result.averages;
          this.date = response.data.result.date_f;
          this.updateChartData();
          this.loading = false;
        },
        onFail: (err) => {
          this.loading = false;
          if (err.response.status === 403) {
            this.$router.push("/login");
          }
        },
      });
    },
    updateChartData() {
      if (!this.statusList || Object.keys(this.statusList).length === 0) return;

      this.chartDataBar = {
        labels: ["Aguardando", "Lavagem", "Acabamento", "Aguard. Entrega"],
        datasets: [
          {
            data: [
              this.queue[this.statusList["aguardando"]]?.length || 0,
              this.queue[this.statusList["lavagem"]]?.length || 0,
              this.queue[this.statusList["acabamento"]]?.length || 0,
              this.queue[this.statusList["concluido"]]?.length || 0,
            ],
            backgroundColor: ["#0053ed", "#00f6ff", "#333333", "#198754"],
          },
        ],
      };

      this.chartDataPie = {
        labels: ["Aguardando", "Lavagem", "Acabamento"],
        datasets: [
          {
            backgroundColor: ["#0053ed", "#00f6ff", "#333333"],
            data: [
              this.averages[this.statusList["aguardando"]]?.seconds || 0,
              this.averages[this.statusList["lavagem"]]?.seconds || 0,
              this.averages[this.statusList["acabamento"]]?.seconds || 0,
            ],
          },
        ],
      };
    },
    getOsDetail(id) {
      this.modalLoading = true;
      Helper.axiosRequest({
        url: `/admin/car?key=id&val=${id}`,
        onSuccess: (response) => {
          this.modalLoading = false;
          this.osDetail = response.data.car;
          $("#modal-monitor-detail").modal("show");
        },
        onFail: () => {
          this.modalLoading = false;
          Swal.fire("Erro", "Ocorreu um erro ao obter os detalhes.", "error");
        },
      });
    },
    openDetailModal(id) {
      this.getOsDetail(id);
    },
    getStatusList() {
      if (sessionStorage.getItem("statusList")) {
        this.statusList = JSON.parse(sessionStorage.getItem("statusList"));
      } else {
        Helper.axiosRequest({
          url: "/lookup/car-clean-status",
          onSuccess: (response) => {
            delete response.data.Cancelado;
            this.statusList = response.data;
            sessionStorage.setItem("statusList", JSON.stringify(response.data));
          },
        });
      }
    },
    deliverAll() {
      Swal.fire({
        title: "Atenção",
        text: "Confirmar a entrega de todos os veículos na lista de \"Aguardando entrega\"?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#707070",
        confirmButtonText: "Confirmar entregas",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          Helper.axiosRequest({
            url: "/admin/car/confirm-deliveries",
            method: "post",
            onFail: (err) => {
              Swal.fire({
                title: "Ocorreu um erro inesperado",
                html: err.response.data.message,
                icon: "error",
              })
            },
            onSuccess: () => {
              Swal.fire({
                icon: "success",
                title: "Entregas concluídas",
              })
            }
          })
        }
      })
    },
    getServices() {
      let tmpServices = sessionStorage.getItem("tmp_services");
      if (tmpServices) {
        this.services = JSON.parse(tmpServices);
      } else {
        Helper.axiosRequest({
          url: "/manager/service-active",
          onSuccess: (r) => {
            this.services = r.data.list;
            sessionStorage.setItem("tmp_services", JSON.stringify(r.data.list));
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.scrollable-column {
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.mobile-tab-pane {
  height: calc(100vh - 210px); /* Ajuste a altura conforme necessário */
  overflow-y: auto;
}

.vehicle-card {
  transition: all 0.2s ease-in-out;
}

/* Efeito de "lift" opcional ao passar o mouse, mantido para desktops */
@media (min-width: 768px) {
  .vehicle-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
}

.nav-link {
  font-size: 0.8rem;
  padding: 0.5rem 0.2rem;
}

.inline-icon {
  vertical-align: middle;
  font-size: 1.2em;
}
</style>
